import React, {Component} from 'react';
import PrintPreview from './PrintPreview'
import ReportPOAndExpense from '../report/ReportPOAndExpense'
import ReportStore from '../../stores/ReportStore';
import Moment from 'moment';
import Chart from 'chart.js';
import { findDOMNode } from 'react-dom'
import ReportKKCAllYearProfit from '../report/ReportKKCAllYearProfit';

const DEFAULT_ROW = 32
const keyYear = ['jan','feb','mar','apr','may','jun','jul','aug','sep','oct','nov','dec']
const optionsRows = [10,20,50,100]
const optionsYear = []
for (var i = parseInt(Moment().format('YYYY')) + 543; i >= 2557; i--) {
  optionsYear.push({
    value: i,
    label: i
  });
}

class PrintReportKKCAllYearProfit extends Component {
  constructor(...args){
    super(...args)
    
    this.state = {
      loading:false,
      data:{},
      dataList:[],
      report_title:'กำลังดึงข้อมูล..'
    }

    var cssPagedMedia = (function() {
      var style = document.createElement('style');
      document.head.appendChild(style);
      return function (rule) {
        style.innerHTML = rule;
      };
    }());

    cssPagedMedia.size = function(size) {
      cssPagedMedia('@page {size: ' + size + '}');
    };
    cssPagedMedia.size('landscape');
  }

  componentDidMount(){
    let {year} = this.props
    this.loadData(year)
  }

  loadData(year='') {
    this.setState({loading:true})
    ReportStore.loadReportAllYearProfit(parseInt(year)+543,(result)=>{
      this.setState({loading:false,data:result.data,dataList:this.getPagination(result.data),report_title:'ไม่พบข้อมูล'})      
    })
  }

  getNumberFormat(value) {
    let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
    _val = parseFloat(_val)
    return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
  }

  getAmountPerRow(key) {
    let {data} = this.state
    return data[key][0][1]+data[key][0][2]+data[key][0][3]+data[key][0][4]+data[key][0][5]+data[key][0][6]+data[key][0][7]+data[key][0][8]+data[key][0][9]+data[key][0][10]+data[key][0][11]+data[key][0][12]
  }

  getValForChart(key) {
    let that = this
    let income = []
    keyYear.forEach(function(item,index) {
      income.push(that.getColSummary(key,item))
    })
    return income
  }

  renderRowTitle(text) {
    return(
            <tr>
              <td colSpan={2} className='text-center'>{text}</td>
              <td className='text-center'></td>
              <td className='text-center'></td>
              <td className='text-center'></td>
              <td className='text-center'></td>
              <td className='text-center'></td>
              <td className='text-center'></td>
              <td className='text-center'></td>
              <td className='text-center'></td>
              <td className='text-center'></td>
              <td className='text-center'></td>
              <td className='text-center'></td>
              <td className='text-center'></td>
              <td className='text-right'></td>
            </tr>
    )
  }

  renderRowData(key,value,index) {
    if (value.length===0||value===undefined||value===false) {
      return(<tr><td colSpan={15}>ไม่พบข้อมูล</td></tr>)
    } else {
      return(
        <tr>
          <td className='text-center'>{index}</td>
          <td>{value.name}</td>
          {this.renderColMonth(value)}
          <td className='text-right'>{value.sum_amount===0||value.sum_amount==='0'?'':this.getNumberFormat(value.sum_amount)}</td>
        </tr>
      )
    }
  }

  renderColMonth(data) {
        return([
          <td key={0} className='text-right' style={{minWidth:'60px'}}>
            {data[1]===0||data[1]==='0'?'':this.getNumberFormat(data['1'])}
          </td>,
          <td key={1} className='text-right' style={{minWidth:'60px'}}>
            {data[2]===0||data[2]==='0'?'':this.getNumberFormat(data['2'])}
          </td>,
          <td key={2} className='text-right' style={{minWidth:'60px'}}>
            {data[3]===0||data[3]==='0'?'':this.getNumberFormat(data['3'])}
          </td>,
          <td key={3} className='text-right' style={{minWidth:'60px'}}>
            {data[4]===0||data[4]==='0'?'':this.getNumberFormat(data['4'])}
          </td>,
          <td key={4} className='text-right' style={{minWidth:'60px'}}>
            {data[5]===0||data[5]==='0'?'':this.getNumberFormat(data['5'])}
          </td>,
          <td key={5} className='text-right' style={{minWidth:'60px'}}>
            {data[6]===0||data[6]==='0'?'':this.getNumberFormat(data['6'])}
          </td>,
          <td key={6} className='text-right' style={{minWidth:'60px'}}>
            {data[7]===0||data[7]==='0'?'':this.getNumberFormat(data['7'])}
          </td>,
          <td key={7} className='text-right' style={{minWidth:'60px'}}>
            {data[8]===0||data[8]==='0'?'':this.getNumberFormat(data['8'])}
          </td>,
          <td key={8} className='text-right' style={{minWidth:'60px'}}>
            {data[9]===0||data[9]==='0'?'':this.getNumberFormat(data['9'])}
          </td>,
          <td key={9} className='text-right' style={{minWidth:'60px'}}>
            {data[10]===0||data[10]==='0'?'':this.getNumberFormat(data['10'])}
          </td>,
          <td key={10} className='text-right' style={{minWidth:'60px'}}>
            {data[11]===0||data[11]==='0'?'':this.getNumberFormat(data['11'])}
          </td>,
          <td key={11} className='text-right' style={{minWidth:'60px'}}>
            {data[12]===0||data[12]==='0'?'':this.getNumberFormat(data['12'])}
          </td>
        ])
  }

  getAffPerRow(key) {
    let {data} = this.state
    let sum = 0
    data.affiliate.forEach(function(item,index) {
      let value = (item[key]===''||item[key]===null||item[key]===undefined||isNaN(item[key])?0:item[key])
      sum += parseFloat(value)
    })
    return sum
  } 

  renderEmptyRow() {
    return(
      <tr>
        <td colSpan={2} className='text-center'>รวมรายรับสุทธิเหลือในแต่ละเดือน</td>
        <td className='text-right'></td>
        <td className='text-right'></td>
        <td className='text-right'></td>
        <td className='text-right'></td>
        <td className='text-right'></td>
        <td className='text-right'></td>
        <td className='text-right'></td>
        <td className='text-right'></td>
        <td className='text-right'></td>
        <td className='text-right'></td>
        <td className='text-right'></td>
        <td className='text-right'></td>
        <td className='text-right'></td>
      </tr>
    )
  }

  renderSummary(text,key='') {
    let {data} = this.state
    if (data[key][0]===undefined)
      return this.renderEmptyRow()

    return(
      <tr>
        <td colSpan={2} className='text-center'>{text}</td>
        <td className='text-right'>{key==='affiliate'?(this.getAffPerRow(1)===0?'':this.getNumberFormat(this.getAffPerRow(1))):data[key][0][1]===0?'':this.getNumberFormat(data[key][0][1])}</td>
        <td className='text-right'>{key==='affiliate'?(this.getAffPerRow(2)===0?'':this.getNumberFormat(this.getAffPerRow(2))):data[key][0][2]===0?'':this.getNumberFormat(data[key][0][2])}</td>
        <td className='text-right'>{key==='affiliate'?(this.getAffPerRow(3)===0?'':this.getNumberFormat(this.getAffPerRow(3))):data[key][0][3]===0?'':this.getNumberFormat(data[key][0][3])}</td>
        <td className='text-right'>{key==='affiliate'?(this.getAffPerRow(4)===0?'':this.getNumberFormat(this.getAffPerRow(4))):data[key][0][4]===0?'':this.getNumberFormat(data[key][0][4])}</td>
        <td className='text-right'>{key==='affiliate'?(this.getAffPerRow(5)===0?'':this.getNumberFormat(this.getAffPerRow(5))):data[key][0][5]===0?'':this.getNumberFormat(data[key][0][5])}</td>
        <td className='text-right'>{key==='affiliate'?(this.getAffPerRow(6)===0?'':this.getNumberFormat(this.getAffPerRow(6))):data[key][0][6]===0?'':this.getNumberFormat(data[key][0][6])}</td>
        <td className='text-right'>{key==='affiliate'?(this.getAffPerRow(7)===0?'':this.getNumberFormat(this.getAffPerRow(7))):data[key][0][7]===0?'':this.getNumberFormat(data[key][0][7])}</td>
        <td className='text-right'>{key==='affiliate'?(this.getAffPerRow(8)===0?'':this.getNumberFormat(this.getAffPerRow(8))):data[key][0][8]===0?'':this.getNumberFormat(data[key][0][8])}</td>
        <td className='text-right'>{key==='affiliate'?(this.getAffPerRow(9)===0?'':this.getNumberFormat(this.getAffPerRow(9))):data[key][0][9]===0?'':this.getNumberFormat(data[key][0][9])}</td>
        <td className='text-right'>{key==='affiliate'?(this.getAffPerRow(10)===0?'':this.getNumberFormat(this.getAffPerRow(10))):data[key][0][10]===0?'':this.getNumberFormat(data[key][0][10])}</td>
        <td className='text-right'>{key==='affiliate'?(this.getAffPerRow(11)===0?'':this.getNumberFormat(this.getAffPerRow(11))):data[key][0][11]===0?'':this.getNumberFormat(data[key][0][11])}</td>
        <td className='text-right'>{key==='affiliate'?(this.getAffPerRow(12)===0?'':this.getNumberFormat(this.getAffPerRow(12))):data[key][0][12]===0?'':this.getNumberFormat(data[key][0][12])}</td>
        <td className='text-right'>{key==='work'?this.getNumberFormat(data[key][0]['sum_amount']):key==='affiliate'?this.getNumberFormat(this.getAffPerRow('sum_amount')):this.getNumberFormat(this.getAmountPerRow(key))}</td>
      </tr>
    )
  }

  getRowSummary(key) {
    let sum = 0
    sum = parseFloat(this.getColSummary(key,'jan')) + parseFloat(this.getColSummary(key,'feb')) + parseFloat(this.getColSummary(key,'mar')) + parseFloat(this.getColSummary(key,'apr')) + parseFloat(this.getColSummary(key,'may')) + parseFloat(this.getColSummary(key,'jun')) + parseFloat(this.getColSummary(key,'jul')) + parseFloat(this.getColSummary(key,'aug')) + parseFloat(this.getColSummary(key,'sep')) + parseFloat(this.getColSummary(key,'oct')) + parseFloat(this.getColSummary(key,'nov')) + parseFloat(this.getColSummary(key,'dec'))
    return sum
  }  

  getRowValue(key,row) {
    let {data} = this.state
    let sum = 0
    data[key].forEach(function(items,indexs) {
      items.month.forEach(function(item,index) {
        if (indexs===row)
          sum += parseFloat(item.value)
      })
    })
    return sum
  }

  getColSummary(key,month) {
    let {data} = this.state
    let sum = 0
    data[key].forEach(function(items,indexs) {
      items.month.forEach(function(item,index) {
        if (item.label===month)
          sum += parseFloat(item.value)
      })
    })
    return sum
  }

  renderHeadTitle() {
    return([
            <tr>
              <td colSpan={15} className='text-center'>สรุปรายรับ - รายจ่ายประจำปี 2560</td>
            </tr>,
            <tr>
              <td rowSpan={2} className='text-center' style={{width:'50px'}}>ลำดับ</td>
              <td rowSpan={2} className='text-center' style={{width:'300px'}}>รายชื่อลูกค้า</td>
              <td colSpan={12} className='text-center'>รายรับ - รายจ่าย (จ่ายจริง) ของหจก.เคเคซี เกษมการช่าง ประจำปี 2559</td>
              <td rowSpan={2} className='text-center' style={{width:'100px'}}>รวม</td>
            </tr>,
            <tr>
              <td className='text-center' style={{width:'50px'}}>มค.</td>
              <td className='text-center' style={{width:'50px'}}>กพ.</td>
              <td className='text-center' style={{width:'50px'}}>มีค.</td>
              <td className='text-center' style={{width:'50px'}}>เมย.</td>
              <td className='text-center' style={{width:'50px'}}>พค.</td>
              <td className='text-center' style={{width:'50px'}}>มิย.</td>
              <td className='text-center' style={{width:'50px'}}>กค.</td>
              <td className='text-center' style={{width:'50px'}}>สค.</td>
              <td className='text-center' style={{width:'50px'}}>กย.</td>
              <td className='text-center' style={{width:'50px'}}>ตค.</td>
              <td className='text-center' style={{width:'50px'}}>พย.</td>
              <td className='text-center' style={{width:'50px'}}>ธค.</td>
            </tr>
    ])
  }

  renderBody(items,indexs) {
    return(
      items.map((item,index)=>{
        if (item.titleIncome) {
          return(this.renderRowTitle('รายรับ (ยอดเงินหลังหักภาษี ณ ที่จ่าย 3%)'))
        } else if (item.dataIncome!==false) {
          return(this.renderRowData('income',item.dataIncome,item.numberIncome))
        } else if (item.sumIncome) {
          return(this.renderSummary('รวมรายรับเงินสดและเงินโอนจากลูกค้า','total_income'))
        } else if (item.sumIncome1) {
          return(this.renderSummary('รายได้จากรถเข้าซ่อมของเดือน มค. - ธค.','work'))
        } else if (item.titlePOE) {
          return(this.renderRowTitle('รายจ่าย'))
        } else if (item.dataPOE!==false) {
          return(this.renderRowData('poe',item.dataPOE,item.numberPOE))
        } else if (item.sumPOE) {
          return(this.renderSummary('รวมรายจ่ายทั้งสิ้น','total_expense'))
        } else if (item.sumPOE1) {
          return(this.renderSummary('รายได้เงินสดคงเหลือ','balance'))
        } else if (item.sumPOE2) {
          return(this.renderSummary('รายได้จากการเข้าซ่อม คงเหลือสุทธิ','balance_work'))
        } else if (item.titleAff) {
          return(this.renderRowTitle('รายได้จากการซ่อมรถในเครือ'))
        } else if (item.dataAff!==false) {
          return(this.renderRowData('affiliate',item.dataAff,item.numberAff))
        } else if (item.sumAff) {
          return(this.renderSummary('รวมรายรับจากการซ่อมรถในเครือ','affiliate'))
        } else if (item.sumAff1) {
          return(this.renderSummary('รวมรายรับสุทธิเหลือในแต่ละเดือน','profit'))
        }
      })
    )  
  }

  renderTable(items,indexs) {
    return(
      <div className="display-overflow font-16">
        <table className="table table-bordered table-profit">
          <tbody>
            {this.renderHeadTitle()}
            {this.renderBody(items,indexs)}
          </tbody>
        </table>
      </div>
    )
  }

  renderComponentPage(items,indexs) {
    return(
      <div className='font-print' key={indexs}>
        <header style={{float:'none',textAlign:'center'}}>
          <h2 className="text-center">{this.props.title} {parseInt(this.props.year)+543}</h2>
        </header>
        <br/>
        {this.renderTable(items,indexs)}      
      </div>
    )  
  }

  getPagination(data) {
    let newData = []
    let setData = [{titleIncome:true,numberIncome:false,dataIncome:false,sumIncome:false,sumIncome1:false,titlePOE:false,numberPOE:false,dataPOE:false,sumPOE:false,sumPOE1:false,sumPOE2:false,titleAff:false,numberAff:false,dataAff:false,sumAff:false,sumAff1:false}]
    let allData = []
    let checkRow = 0
    
    data.income.forEach(function(item,index) {
      setData.push({
        titleIncome:false,numberIncome:index+1,dataIncome:item,sumIncome:false,sumIncome1:false,titlePOE:false,numberPOE:false,dataPOE:false,sumPOE:false,sumPOE1:false,sumPOE2:false,titleAff:false,numberAff:false,dataAff:false,sumAff:false,sumAff1:false
      })
    })
    setData.push({titleIncome:false,numberIncome:false,dataIncome:false,sumIncome:true,sumIncome1:false,titlePOE:false,numberPOE:false,dataPOE:false,sumPOE:false,sumPOE1:false,sumPOE2:false,titleAff:false,numberAff:false,dataAff:false,sumAff:false,sumAff1:false})
    setData.push({titleIncome:false,numberIncome:false,dataIncome:false,sumIncome:false,sumIncome1:true,titlePOE:false,numberPOE:false,dataPOE:false,sumPOE:false,sumPOE1:false,sumPOE2:false,titleAff:false,numberAff:false,dataAff:false,sumAff:false,sumAff1:false})
    setData.push({titleIncome:false,numberIncome:false,dataIncome:false,sumIncome:false,sumIncome1:false,titlePOE:true,numberPOE:false,dataPOE:false,sumPOE:false,sumPOE1:false,sumPOE2:false,titleAff:false,numberAff:false,dataAff:false,sumAff:false,sumAff1:false})
    data.poe.forEach(function(item,index) {
      setData.push({
        titleIncome:false,numberIncome:false,dataIncome:false,sumIncome:false,sumIncome1:false,titlePOE:false,numberPOE:index+1,dataPOE:item,sumPOE:false,sumPOE1:false,sumPOE2:false,titleAff:false,numberAff:false,dataAff:false,sumAff:false,sumAff1:false
      })
    })
    setData.push({titleIncome:false,numberIncome:false,dataIncome:false,sumIncome:false,sumIncome1:false,titlePOE:false,numberPOE:false,dataPOE:false,sumPOE:true,sumPOE1:false,sumPOE2:false,titleAff:false,numberAff:false,dataAff:false,sumAff:false,sumAff1:false})
    setData.push({titleIncome:false,numberIncome:false,dataIncome:false,sumIncome:false,sumIncome1:false,titlePOE:false,numberPOE:false,dataPOE:false,sumPOE:false,sumPOE1:true,sumPOE2:false,titleAff:false,numberAff:false,dataAff:false,sumAff:false,sumAff1:false})
    setData.push({titleIncome:false,numberIncome:false,dataIncome:false,sumIncome:false,sumIncome1:false,titlePOE:false,numberPOE:false,dataPOE:false,sumPOE:false,sumPOE1:false,sumPOE2:true,titleAff:false,numberAff:false,dataAff:false,sumAff:false,sumAff1:false})
    setData.push({titleIncome:false,numberIncome:false,dataIncome:false,sumIncome:false,sumIncome1:false,titlePOE:false,numberPOE:false,dataPOE:false,sumPOE:false,sumPOE1:false,sumPOE2:false,titleAff:true,numberAff:false,dataAff:false,sumAff:false,sumAff1:false})
    data.affiliate.forEach(function(item,index) {
      setData.push({
        titleIncome:false,numberIncome:false,dataIncome:false,sumIncome:false,sumIncome1:false,titlePOE:false,numberPOE:false,dataPOE:false,sumPOE:false,sumPOE1:false,sumPOE2:false,titleAff:false,numberAff:index+1,dataAff:item,sumAff:false,sumAff1:false
      })
    })
    setData.push({titleIncome:false,numberIncome:false,dataIncome:false,sumIncome:false,sumIncome1:false,titlePOE:false,numberPOE:false,dataPOE:false,sumPOE:false,sumPOE1:false,sumPOE2:false,titleAff:false,numberAff:false,dataAff:false,sumAff:true,sumAff1:false})
    setData.push({titleIncome:false,numberIncome:false,dataIncome:false,sumIncome:false,sumIncome1:false,titlePOE:false,numberPOE:false,dataPOE:false,sumPOE:false,sumPOE1:false,sumPOE2:false,titleAff:false,numberAff:false,dataAff:false,sumAff:false,sumAff1:true})
    
    setData.forEach(function(item,index) {
      if (checkRow<DEFAULT_ROW) {
        newData.push(item)
        checkRow++
      }
      if (checkRow===DEFAULT_ROW-1||index===setData.length-1) {
        allData.push(newData)
        newData = []
        checkRow = 0
      }
    })

    return allData   
  }

  renderNoData() {
    return(
      <div className='font-print'>
        <header className="text-center">
          <h2>{this.state.report_title}</h2>
        </header>
      </div>
    )
  }

  render() {
    let {data,dataList,loading} = this.state
    let {year} = this.props

    year = parseInt(year)+543
    if (this.props.typePrint==='chart') {
      return(
        <PrintPreview 
          loading={loading} 
          size={'landscape'}
          leftBarTitle={this.props.title+' '+year}
        >
          <ReportKKCAllYearProfit
            typePrint={'chart'}
            showPrintPreview={true}
            titleBarChat={this.props.title+' '+year}
            year={year}
          >
          </ReportKKCAllYearProfit>
        </PrintPreview>
      )
    } else {
      if (dataList.length===0) {
        return(
          <PrintPreview 
            loading={loading} 
            size={'landscape'}
            leftBarTitle={this.props.title+' '+year}
          >
            {this.renderNoData()}
          </PrintPreview>
        )  
      } else {
        return(
          <PrintPreview 
            loading={this.state.loading} 
            size={'landscape'}
            leftBarTitle={this.props.title+' '+year}
          >
            {
              dataList.map((item,index) => {
                return(
                  this.renderComponentPage(item,index)
                )
              })
            }
          </PrintPreview>
        )
      }  
    }    
  }
}

PrintReportKKCAllYearProfit.defaultProps = {
  title: 'รายงานสรุปรายรับรายจ่ายประจำปี',  
  mode : '',
  workNo : ''
}
export default PrintReportKKCAllYearProfit;    


// WEBPACK FOOTER //
// ./src/view/print/PrintReportKKCAllYearProfit.js